import { ReactNode } from "react";
import { Control, FieldErrors, UseFormClearErrors, UseFormUnregister } from "react-hook-form";

export interface IPermissions {
    id: number;
    efa005Id?: number;
    efa005Nome?: string;
    efa004Id?: number;
    efa004Descricao?: string;
    permission?: string;
}

export interface IComponentPermissions{
    register: (RegisterOptions?: any) => void;
    unregister: UseFormUnregister<any>;
    control: Control<any>;
    error: FieldErrors<any>;
    clearErrors: UseFormClearErrors<any>;
    disabled?: boolean;
    permissionsNames: {
        nameObject: string;
        nameOfID: string;
        nameOfSelectUser: string;
        nameOfSelectUserDescription?: string;
        nameOfSelectGroup: string;
        nameOfSelectGroupDescription?: string;
        nameOfSelectPermission?: string;
        defaultValue: any;
    };
    permissionType?: "simple" | "complete" | "hidePermissions" |"report";
    customPermissionOptions?: {
        value: string;
        label: string;
    }[];
    additionalFields?: (register: (RegisterOptions?: any) => void, control: Control<any>, error: FieldErrors<any>, prefixNamesInputs: string, permission: IPermissions, updatePermissions: (value: any, key: string) => void) => ReactNode;
}

export enum reportPermissionType{
    NO_PERMISSION = "0",
    VIEW = "1"
}

export enum simplePermissionType{
    NO_PERMISSION = "0",
    VIEW = "1",
    VIEW_AND_EDIT = "2"
}

export enum completePermissionType{
    NO_PERMISSION = "0",
    VIEW = "1",
    VIEW_AND_ANALIZE="2",
    VIEW_AND_CHANGE_VALUES="3",
    VIEW_AND_CHANGE_VALUES_GOAL = "4",
    VIEW_AND_EDIT = "5"
}
